export default [
    {
        path: '/h5Dindex',
        name: 'h5Dindex',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../../views/h5views_d/index.vue'),  
    },
    {
        path: '/h5Dindex/test',
        name: 'minitest',
        component: () => import(/* webpackChunkName: "about" */ '../../views/h5views_d/minitest/test')
    },
    {
        path: '/h5Dindex/video',
        name: 'video_d',
        component: () => import(/* webpackChunkName: "about" */ '../../views/h5views_d/video')
    },
    {
        path: '/h5Dindex/tuwen',
        name: 'tuwen_d',
        component: () => import(/* webpackChunkName: "about" */ '../../views/h5views_d/tuwen')
    },
    {
        path: '/h5Dindex/headVideo',
        name: 'headVideo_d',
        component: () => import(/* webpackChunkName: "about" */ '../../views/h5views_d/headVideo')
    },
    {
        path: '/h5Dindex/footVideo',
        name: 'footVideo_d',
        component: () => import(/* webpackChunkName: "about" */ '../../views/h5views_d/footVideo')
    },
    {
        path: '/h5Dindex/preview',
        name: 'preview_d',
        component: () => import(/* webpackChunkName: "about" */ '../../views/h5views_d/preview')
    },
]